import Hero from '@/pages/home/components/Hero';
import FeaturedTopics from '@/pages/home/components/FeaturedTopics';
import CategoryStrip from '@/pages/home/components/CategoryStrip';
import Principles from '@/pages/home/components/Principles';
import RankingsPreview from '@/pages/home/components/RankingsPreview';
import FaqSection from '@/pages/home/components/FaqSection';
import Newsletter from '@/pages/home/components/Newsletter';
import { useSeo } from '@/hooks/useSeo';
import { topics } from '@/mocks/topics';
import { faqs, siteConfig } from '@/mocks/site';

export default function Home() {
  useSeo({
    title: '黑料社网 - 专题合集与精选盘点分类榜单门户',
    description:
      '黑料社网把网络热点、娱乐话题、流行梗与名场面按主题整理成专题合集，并配套分类榜单，一次性看够，省去逐个查找的时间。',
    keywords: '黑料社网,专题合集,精选盘点,分类榜单,网络热点,娱乐话题',
    canonicalPath: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteConfig.name,
        url: 'https://jinpenge.cn/',
        description: siteConfig.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://jinpenge.cn/topics?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteConfig.name,
        url: 'https://jinpenge.cn/',
        email: siteConfig.email,
        foundingDate: siteConfig.since,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '本周精选专题合集',
        itemListElement: topics.slice(0, 5).map((t, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: t.title,
          url: `https://jinpenge.cn/topic/${t.slug}`,
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <FeaturedTopics />
      <CategoryStrip />
      <Principles />
      <RankingsPreview />
      <FaqSection />
      <Newsletter />
    </>
  );
}